import pageHeader from "../components/pageHeader/locals/en.json";

export default {
  pageHeader,

};
